import { PlusOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { Dropdown, Space } from "antd";

import { DatePicker } from "../../../components/antOverrides";
import moment from "moment";
import React, { useState, Fragment } from "react";
import ButtonDropdown from "./ButtonDropdown";
import MemberDropdown from "./MemberDropdown";
import RemoveButtonGroup from "./RemoveButtonGroup";
import { SectionRow } from "../components";
import styled from "styled-components";

const Label = styled.div`
  color: var(--dark-03-color);
  line-height: 32px;
`;

const { RangePicker } = DatePicker;

const TimeGroup = ({
  members = [],
  availableMembers,
  addMemberName,
  updateMethods,
  parsedDateRange,
  intl,
}) => {
  const isCustomDateRange = Array.isArray(members[0]?.dateRange);
  const [isRangePickerVisible, toggleRangePicker] = useState(false);
  const DateRanges = [
    {
      title: intl.formatMessage({
        id: "app.reports.custom",
      }),
      value: "custom",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.allTime",
      }),
      value: undefined,
    },
    {
      title: intl.formatMessage({
        id: "app.reports.today",
      }),
      value: "Today",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.yesterday",
      }),
      value: "Yesterday",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.thisWeek",
      }),
      value: "This week",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.thisMonth",
      }),
      value: "This month",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.thisQuarter",
      }),
      value: "This quarter",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.thisYear",
      }),
      value: "This year",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.last7Days",
      }),
      value: "Last 7 days",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.last30Days",
      }),
      value: "Last 30 days",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.lastWeek",
      }),
      value: "Last week",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.lastMonth",
      }),
      value: "Last month",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.lastQuarter",
      }),
      value: "Last quarter",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.lastYear",
      }),
      value: "Last year",
    },
    {
      title: intl.formatMessage({
        id: "app.reports.last360Days",
      }),
      value: "last 360 days",
    },
  ];
  function onDateRangeSelect(m, dateRange) {
    if (dateRange && !dateRange.some((d) => !d)) {
      updateMethods.update(m, {
        ...m,
        dateRange: dateRange.map((dateTime) => dateTime.format("YYYY-MM-DD")),
      });
    }
  }

  const granularityMenu = (member, onClick) => {
    const items = member.dimension.granularities.map((i) => {
      return {
        label: intl.formatMessage({
          id: `app.reports.${i.title}`,
        }),
        key: i.title,
        onClick: (k) => {
          updateMethods.update(member, { ...member, granularity: i.name });
        },
      };
    });

    return items;
  };

  const dateRangeMenu = (m) => {
    const items = DateRanges.map((i) => {
      return {
        label: i.title || i.value,
        key: i.value,
        onClick: (k) => {
          if (i.value === "custom") {
            toggleRangePicker(true);
          } else {
            updateMethods.update(m, {
              ...m,
              dateRange: i.value,
            });
            toggleRangePicker(false);
          }
        },
      };
    });

    return items;
  };

  return (
    <SectionRow>
      {members.map((m, index) => (
        <Fragment key={index}>
          <RemoveButtonGroup onRemoveClick={() => updateMethods.remove(m)}>
            <MemberDropdown
              onClick={(updateWith) =>
                updateMethods.update(m, { ...m, dimension: updateWith })
              }
              availableMembers={availableMembers}
              intl={intl}
            >
              {intl.formatMessage({
                id: `app.analytics.${m.dimension.name}`,
                defaultMessage: `${m.dimension.title}`,
              })}
            </MemberDropdown>
          </RemoveButtonGroup>

          <Label>
            {intl.formatMessage({
              id: "app.reports.for",
            })}
          </Label>

          <ButtonDropdown items={dateRangeMenu(m)}>
            {isRangePickerVisible || isCustomDateRange
              ? intl.formatMessage({
                  id: "app.reports.custom",
                })
              : DateRanges.filter((i) => i.value === m.dateRange)[0].title}
          </ButtonDropdown>

          {isRangePickerVisible || isCustomDateRange ? (
            <RangePicker
              format="YYYY-MM-DD"
              inputReadOnly={true}
              defaultValue={(parsedDateRange || []).map((date) => moment(date))}
              onChange={(dateRange) => onDateRangeSelect(m, dateRange)}
            />
          ) : null}

          <Label>
            {intl.formatMessage({
              id: "app.reports.by",
            })}
          </Label>

          <ButtonDropdown items={granularityMenu(m)}>
            {m.dimension.granularities.find((g) => g.name === m.granularity) &&
            m.dimension.granularities.find((g) => g.name === m.granularity)
              .title
              ? intl.formatMessage({
                  id: `app.reports.${
                    m.dimension.granularities.find(
                      (g) => g.name === m.granularity
                    ).title
                  }`,
                })
              : ""}
          </ButtonDropdown>
        </Fragment>
      ))}

      {!members.length && (
        <MemberDropdown
          availableMembers={availableMembers}
          type="dashed"
          icon={<PlusOutlined />}
          onClick={(member) =>
            updateMethods.add({
              dimension: member,
              granularity: "day",
              dateRange: "This month",
            })
          }
          intl={intl}
        >
          {addMemberName}
        </MemberDropdown>
      )}
    </SectionRow>
  );
};

export default TimeGroup;
